import React, { ChangeEvent } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';
import Viewer from 'react-viewer';
import moment from 'moment';
import config from 'config';
import { encodeFileName } from '../../../helpers/filesPreview';

function CancelationForm(props: any) {
  const { data, setData, setResolucionFile, gallery, galleryContainer, isLoading, onAccept, onReject } = props;

  const archivoResolucion = data.attachs?.find(
    (a: { attachment_type: string }) => a.attachment_type === 'archivo_resolucion',
  );

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Matriculado
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.matricula || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.delegacion || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.nombre || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.apellido || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Solicitud
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Fecha de Baja efectiva</label>
                <p>{
                  !!data.fecha_cancelacion && moment(data.fecha_cancelacion, 'YYYY-MM-DD').isValid()
                    ? moment(data.fecha_cancelacion, 'YYYY-MM-DD').format('DD/MM/YYYY')
                    : '-'
                }</p>
              </FormGroup>
            </Col>
            <Col sm={6}></Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Motivo de solicitud</label>
                <p>{ data.motivo_solicitud || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          { data.state_id == 1
            ?
              <>
                <hr className="my-4" />
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <label className='form-control-label'>Número Resolución</label>
                      <Input
                        id="nro_resolucion"
                        name="nro_resolucion"
                        type="number"
                        value={data.nro_resolucion ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <label className='form-control-label'>Año Resolución</label>
                      <Input
                        id="ano_resolucion"
                        name="ano_resolucion"
                        type="number"
                        value={data.ano_resolucion ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <label className='form-control-label'>Archivo de Resolución (PDF)</label>
                      <Input
                        id="archivo_resolucion"
                        name="archivo_resolucion"
                        type="file"
                        accept="application/pdf"
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          setResolucionFile?.(event.target.files?.[0] ?? null);
                        }}
                        disabled={isLoading}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <hr className="my-4" />
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <label className='form-control-label'>Motivo de rechazo</label>
                      <Input
                        id="motivo_rechazo"
                        name="motivo_rechazo"
                        type="textarea"
                        value={data.motivo_rechazo ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </>
            : null
          }
          { data.state_id == 2
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Datos adicionales
                </h6>
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <label className='form-control-label'>Número Resolución</label>
                      <p>{ data.nro_resolucion }</p>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <label className='form-control-label'>Año Resolución</label>
                      <p>{ data.ano_resolucion }</p>
                    </FormGroup>
                  </Col>
                </Row>
                { archivoResolucion
                  ?
                    <Row>
                      <Col sm={12}>
                        <FormGroup>
                          <label className='form-control-label'>Archivo de Resolución</label>
                          <p>
                            <a
                              href={`${config.baseUrl}/${encodeFileName(archivoResolucion.url)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Ver PDF
                            </a>
                          </p>
                        </FormGroup>
                      </Col>
                    </Row>
                  : null
                }
              </>
            : null
          }
          { data.state_id == 3
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Rechazo
                </h6>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <label className='form-control-label'>Motivo de rechazo</label>
                      <p>{ data.motivo_rechazo }</p>
                    </FormGroup>
                  </Col>
                </Row>
              </>
            : null
          }
        </Col>
        <Col sm={6}>
          <div className="">
            <label className="form-control-label">Adjuntos</label>
            <div
              id="gallery-container"
              style={{ height: '80vh' }}
              ref={galleryContainer}
            >
              {Array.isArray(gallery) &&
              gallery.length &&
              galleryContainer.current ? (
                    <Viewer
                      container={galleryContainer.current}
                      noClose={true}
                      visible={true}
                      disableMouseZoom={true}
                      downloadable={true}
                      disableKeyboardSupport={true}
                      zoomSpeed={0.5}
                      downloadInNewWindow={true}
                      noImgDetails={true}
                      scalable={false}
                      showTotal={false}
                      defaultScale={1.25}
                      defaultImg={{
                        src: require('../../../assets/img/404.png'),
                      }}
                      images={gallery}
                    />
                  ) : null}
            </div>
          </div>
        </Col>
      </Row>
      {
        data.state_id == 1 && onAccept && onReject
          ? <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
    </Form>
  );
}

export default CancelationForm;
